import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import * as React from 'react';

import { ColorProp, usePaletteColor } from '../theme';
import { prepareTextTransform, TypographyVariant } from '../typography';

export interface LinkProps
    extends TypedOmit<MuiLinkProps, 'color' | 'variant'> {
    variant?: TypographyVariant;
    color?: ColorProp;
    whiteSpace?: React.CSSProperties['whiteSpace'];
    textOverflow?: React.CSSProperties['textOverflow'];
    overflow?: React.CSSProperties['overflow'];
    textTransform?: React.CSSProperties['textTransform'] | 'sentence';
}

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
    (props, ref) => {
        const {
            color = 'primary',
            variant,
            textTransform,
            textOverflow,
            overflow,
            whiteSpace,
            children,
            ...muiProps
        } = props;
        const paletteColor = usePaletteColor(color);

        const cssTextTransform =
            textTransform === 'sentence' ? undefined : textTransform;

        const resolvedVariant = variant ?? ('body2' as MuiLinkProps['variant']);

        return (
            <MuiLink
                ref={ref}
                underline="hover"
                {...muiProps}
                variant={resolvedVariant}
                sx={{
                    color: paletteColor,
                    '&:hover': {
                        color: paletteColor
                    },
                    cursor: props.onClick ? 'pointer' : undefined,
                    textTransform: cssTextTransform,
                    textOverflow,
                    overflow,
                    whiteSpace,
                    ...muiProps.sx
                }}
            >
                {prepareTextTransform(children, textTransform)}
            </MuiLink>
        );
    }
);
